<template>
  <div>
    <b-form-group label="CNPJ:">
      <b-form-input
        v-model="cnpj_value"
        placeholder="CNPJ"
        :state="validateState('cnpj')"
      ></b-form-input>
      <b-form-invalid-feedback
        >CNPJ é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Nome:">
      <b-form-input
        v-model="cnpj.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <h3>Estados e Municípios</h3>
    <b-form-group label="Estados:">
      <SelectMultiEstado v-model="cnpj.estados" />
    </b-form-group>

    <b-form-group label="Municípios:">
      <SelectMultiMunicipio v-model="cnpj.municipios" />
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import SelectMultiMunicipio from "@/modules/municipios/Components/SelectMultiMunicipio";
import SelectMultiEstado from "@/modules/municipios/Components/SelectMultiEstado";
import { cnpj } from "cpf-cnpj-validator";

export default {
  mixins: [validationMixin],
  components: { SelectMultiMunicipio, SelectMultiEstado },
  data: () => ({}),
  validations: {
    cnpj: {
      cnpj: {
        required,
        cnpj: (value) => {
          return !value || cnpj.isValid(value);
        },
      },
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("cnpj", ["cnpj"]),
    cnpj_value: {
      set(value) {
        value = value.replace(/\D/g, "");
        this.cnpj.cnpj = value;
      },
      get() {
        let value = this.$options.filters.cnpj(this.cnpj.cnpj);
        return value;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.cnpj[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.cnpj.$touch();
      return !this.$v.cnpj.$anyError;
    },
    formatterCnpj(value) {
      value = value.replace(/\D/g, "").substring(0, 14);
      value = value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
      return value;
    },
  },
  created() {},
};
</script>
